import React, { useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MainNavigation from '../components/MainNavigation';
import MobileNavigation from '../components/MobileNavigation';
import Footer from '../components/Footer';
import './Root.css';
import { MobileContext } from '../providers/MobileContext';
import { Helmet } from 'react-helmet';

function RootLayout() {
    const isMobile = useContext(MobileContext);
    const location = useLocation();
    const canonicalUrl = 'https://squareplan.io' + location.pathname + location.search;


    return (
        <>
            <Helmet>
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>
            {isMobile ? <MobileNavigation property1="variant-2" /> : <MainNavigation />}
            <main className="content">
                <div className="root-container">
                    <Outlet />
                </div>
            </main>
            <div className="footer-wrapper">
                <Footer />
            </div>
        </>
    );
}

export default RootLayout;
